import { useEffect, useState, useMemo } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { 
  useDeleteDevelpmentPlanMutation, 
  useGetDevelopmentTypeListQuery,
} from "../../../../api/hrApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import DeleteItemModal from "../../../Components/Modals/DeleteItemModal";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import Pagination from "../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table"; 
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions"; 
import { DEFINED_PERMISSIONS } from "../../../../../utils/const"; 
import DevelopmentPlanModal from "./Modals/DevelopmentTypeModal";
import EditDevelopmentTypeModal from "./Modals/EditDevelopmentTypeModal";
import { FilterByStatus } from "./status";
import { getStatusText } from "../../Finance/CostCenter/Class";
const DevelopmentPlan = () => {
  const [onDelete] = useDeleteDevelpmentPlanMutation();
  const [openModal, setOpenModal] = useState(false);
  const [openCreatModal, setOpenCreatModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
    ];

    // Check if userPerm exists and matches any permission in hrPerm
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm); // Set matchedPermissionHr to the matched permission
    } else {
      setMatchedPermissionHr(""); // Reset to empty string if not matched
    }
  }, []);
  const navigate = useNavigate();
  const handleModal = () => {
    setOpenModal(!openModal);
  };
  const handleOpenCreateModale = () => {
    setOpenCreatModal(!openCreatModal);
  };
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const { data, isLoading, refetch } = useGetDevelopmentTypeListQuery({
    Search: searchText,
    PageNumber: currentPage,
    PageSize: pageSize,
    StartDate: startDate,
    EndDate: endDate,
    ApprovalStatus: filter,
  });
  const actionButton = (
    <>
      <CTAButtons onClick={handleOpenCreateModale}>
        Create Development Plan
      </CTAButtons>
    </>
  );
  const handleOpenDeleteModal = (id) => {
    if (id) {
      setSelectedId(id);
      setOpenDelete(true);
    }
  };
  const handleCloseDelete = () => {
    setSelectedId(null);
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    try {
      const response = await onDelete({
        id: parseInt(selectedId),
      }).unwrap();
      if (response?.successful) {
        handleCloseDelete();
        toast.success(response?.statusMessage);
        refetch();
      } else {
        toast.error(response?.data?.title);
      }
    } catch (error) {
      toast.error(
        error?.data?.statusMessage ?? "Error deleting Development Plan"
      );
    }
  };
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };
  const handleEdit = (id) => {
    if (id) {
      setSelectedId(id);
      handleModal();
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!data?.result) return [];
    return [...data.result].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      if (sortColumn === "createdDate") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data?.result, sortColumn, sortDirection]);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return <FaSort className="ml-1" />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ml-1" />
    ) : (
      <FaSortDown className="ml-1" />
    );
  };

  return (
    <PageStyle
      action={actionButton}
      hasBack={true}
      backURL={"/dashboard/hr/HR-Appraisal-Setup"}
      support={
        "Used to manage development Plan applied in performance plans (PIP)"
      }
      demoTitle={"Development Plan"}
      hasTopPageDemo
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={FilterByStatus}
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th
                onClick={() => handleSort("title")}
                style={{ cursor: "pointer" }}
              >
                Title {renderSortIcon("title")}
              </th>
              <th
                onClick={() => handleSort("createdBy")}
                style={{ cursor: "pointer" }}
              >
                Initiator's Name {renderSortIcon("createdBy")}
              </th>
              <th
                onClick={() => handleSort("approvalStatus")}
                style={{ cursor: "pointer" }}
              >
                Approval Status {renderSortIcon("approvalStatus")}
              </th>
              <th
                onClick={() => handleSort("createdDate")}
                style={{ cursor: "pointer" }}
              >
                Created Date {renderSortIcon("createdDate")}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  Loading...
                </td>
              </tr>
            ) : sortedData?.length > 0 ? (
              sortedData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.title}</td>
                  <td>{item?.createdBy}</td>
                  <td>
                    {typeof item?.approvalStatus === "number"
                      ? getStatusText(item?.approvalStatus)
                      : item?.approvalStatus}
                  </td>
                  <td>{FormatDateTime(item.createdDate, "DD/MM/YYYY")}</td>
                  <td>
                    <TableActions
                      hasChildren={true}
                      url={
                        matchedPermissionHr && item?.approvalStatus !== 0
                          ? `${item.id}/view`
                          : null
                      }
                    >
                      {[
                        {
                          name: item?.approvalStatus !== 0 ? "Edit" : null,
                          action:
                            item?.approvalStatus !== 0
                              ? () => handleEdit(item.id)
                              : null,
                        },
                        {
                          name:
                            matchedPermissionHr && item?.approvalStatus !== 0
                              ? "View"
                              : null,
                          action: () =>
                            matchedPermissionHr && item?.approvalStatus !== 0
                              ? handleView(item.id)
                              : null,
                        },
                        {
                          name: "Delete",
                          action: () => handleOpenDeleteModal(item.id),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  No development plan Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.totalRows}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />

      {openModal && selectedId && (
        <AppModalTemplate
          width={"600px"}
          isOpen={openModal}
          setIsOpen={handleModal}
        >
          <EditDevelopmentTypeModal
            isOpen={openModal}
            setIsOpen={setOpenModal}
            onValidate={() => {handleModal();  refetch()}}
            id={selectedId}
          />
        </AppModalTemplate>
      )}
      {openCreatModal && (
        <AppModalTemplate
          width={"600px"}
          isOpen={openCreatModal}
          setIsOpen={handleOpenCreateModale}
        >
          <DevelopmentPlanModal
            isOpen={openCreatModal}
            setIsOpen={setOpenCreatModal}
            onValidate={handleOpenCreateModale}
          />
        </AppModalTemplate>
      )}
      <DeleteItemModal
        isOpen={openDelete}
        handleClose={handleCloseDelete}
        handleDelete={handleDelete}
        headText={"Delete Development Plan"}
        infoText={"Are you sure you want to Delete this Development Plan?"}
      />
    </PageStyle>
  );
};

export default DevelopmentPlan;
